import {useState} from "react";
import {MenuItems} from "../data/Menu/Navigation.config";
import MobileMenuItemList from "./common/MobileMenuItemList";
import {Languages} from "../data/Languages.config";
import IconClose from "../data/Icons/leon-inmobiliaria-icons-close.svg";
import IconSprache from "../data/Icons/leon-inmobiliaria-icons-sprache.svg";
import IconArrowDown from "../data/Icons/leon-inmobiliaria-icons-arrow-1-down.svg";
import {useTranslation} from "next-i18next";

export default function MobileMenu(props: { open: boolean; onClose: () => void }) {
	const [menuLevelItems, setMenuLevelItems] = useState(MenuItems);
	const [hasOpenedLanguageMenu, setHasOpenedLanguageMenu] = useState(false);
	const {t} = useTranslation();
	return (
		<div
			className={`bg-leo-light-gray w-screen h-full xl:hidden flex-col fixed top-0 z-20 ${
				props.open ? "flex" : "hidden"
			}`}
		>
			<div className="flex flex-col justify-between p-4">
				<button onClick={props.onClose} className="self-end mx-6 text-leo-button-gray w-5 h-5">
					<IconClose/>
				</button>
			</div>
			<div className="grow">
				<MobileMenuItemList
					onClose={() => {
						setHasOpenedLanguageMenu(false);
						setMenuLevelItems(MenuItems);
						props.onClose();
					}}
					languageMenu={hasOpenedLanguageMenu}
					menuItems={menuLevelItems}
					onMenuLevelChange={(selectedMenuLevel) => {
						selectedMenuLevel === "topLevel"
							? setMenuLevelItems(MenuItems)
							: setMenuLevelItems(
								MenuItems.find((item) => item.label === selectedMenuLevel)?.submenuItems ?? MenuItems
							);
						setHasOpenedLanguageMenu(false);
					}}
				/>
			</div>
			{!hasOpenedLanguageMenu && (
				<button
					/* className="flex w-full justify-between items-center justify-self-end h-12 bg-white" */
					className="h-20 bg-white relative  justify-between bottom-0 px-6 w-full flex items-center justify-center"
					onClick={() => {
						setMenuLevelItems(
							Languages.map((language) => {
								return {label: language.language, url: language.url};
							})
						);
						setHasOpenedLanguageMenu(true);
					}}
				>
					<div className="flex gap-x-4 px-6 items-center">
						<div className="w-5 h-5 text-leo-button-gray">
							<IconSprache/>
						</div>
						<div>{t("components.mobileMenu.languages")}</div>
					</div>
					<div className="px-6">
						<div className="w-3.5 h-3.5 text-leo-button-gray">
							<IconArrowDown className="-rotate-90"/>
						</div>
					</div>
				</button>
			)}
		</div>
	);
}
